import { Axios } from "@lib";
import type { ChecklistAnswerSubmitParams } from "../types";

export async function checklistAnswerSubmit(
	payload: ChecklistAnswerSubmitParams
) {
	const { answerId, body } = payload;

	const { data } = await Axios.put(
		`/api/checklist/answer/${answerId}/submit`,
		body
	);

	return data;
}
